import React from 'react';
export function IdentificationSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-110">
      <div className="max-w-3xl mx-auto text-center" data-id="element-111">
        <div className="inline-flex bg-brand-purpleLight text-brand-purpleDark px-4 py-1.5 rounded-full font-semibold text-sm mb-6" data-id="element-112">
          Identificate
        </div>

        <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-darkGray mb-10" data-id="element-113">
          ¿Te suena familiar esto?
        </h2>

        <div className="bg-brand-purple text-white rounded-2xl p-8 md:p-12 shadow-xl text-lg md:text-xl font-medium leading-relaxed mb-8 text-left relative overflow-hidden" data-id="element-114">
          <div className="absolute top-0 right-0 w-32 h-32 bg-white/5 rounded-full blur-2xl -mr-10 -mt-10" data-id="element-115"></div>
          <p className="relative z-10" data-id="element-116">
            Son las 7 de la tarde. Abrís la heladera, la mirás, la cerrás. La
            volvés a abrir. Nada cambia. Al final pedís delivery otra vez, o
            comés cualquier cosa parada frente a la mesada. Y la air fryer ahí,
            tapada con algo encima.
          </p>
        </div>

        <p className="text-xl text-brand-mediumGray font-medium" data-id="element-117">
          Si esto te pasa seguido, no es falta de ganas.{' '}
          <span className="text-brand-purpleDark font-bold" data-id="element-118">
            Es falta de un sistema.
          </span>
        </p>
      </div>
    </section>;
}